(() => {
  const FRENCH_LOCALE_PREFIX = 'fr';

  /**
   * @param {number} value
   * @param {number} precision
   * @param {string} thousands
   * @param {string} decimal
   * @returns {string}
   */
  function formatWithDelimiters(value, precision, thousands, decimal) {
    const fixed = value.toFixed(precision);
    const [whole, fraction] = fixed.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return precision > 0 ? `${grouped}${decimal}${fraction}` : grouped;
  }

  /**
   * @param {number} value Major currency units.
   * @returns {string}
   */
  function formatFrench(value) {
    return `${formatWithDelimiters(value, 2, ' ', ',')} $`;
  }

  /**
   * @param {number} value Major currency units.
   * @returns {string}
   */
  function formatShopMoney(value) {
    const format = window.themeSettings?.moneyFormat || '${{amount}}';
    const replacements = {
      amount: formatWithDelimiters(value, 2, ',', '.'),
      amount_no_decimals: formatWithDelimiters(value, 0, ',', '.'),
      amount_with_comma_separator: formatWithDelimiters(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: formatWithDelimiters(value, 0, '.', ','),
      amount_with_space_separator: formatWithDelimiters(value, 2, ' ', ','),
      amount_no_decimals_with_space_separator: formatWithDelimiters(value, 0, ' ', ','),
      amount_with_period_and_space_separator: formatWithDelimiters(value, 2, ' ', '.'),
      amount_with_apostrophe_separator: formatWithDelimiters(value, 2, "'", '.'),
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => replacements[key] ?? match);
  }

  /**
   * Format a price supplied in cents.
   * @param {number|string} cents
   * @returns {string}
   */
  function format(cents) {
    const numericCents = Number(cents);
    const value = Number.isFinite(numericCents) ? numericCents / 100 : 0;
    const locale = document.documentElement.lang.toLowerCase();
    return locale.startsWith(FRENCH_LOCALE_PREFIX) ? formatFrench(value) : formatShopMoney(value);
  }

  /**
   * Format a price supplied in major currency units, such as an Algolia PPU value.
   * @param {number|string} value
   * @returns {string}
   */
  function formatMajor(value) {
    const numericValue = Number(value);
    return format(Number.isFinite(numericValue) ? Math.round(numericValue * 100) : 0);
  }

  window.OCSMoney = Object.freeze({ format, formatMajor });
})();
